import {Stack, Typography} from "@mui/material";
import React from "react";

interface FormFieldProps {
    title: String;
    value: String | undefined;
}

export default function FormField({title, value} : FormFieldProps) {
    return (
        <Stack>
            <Typography variant='overline'>{title}</Typography>
            <Typography id="display-name-text">{value || '-'}</Typography>
        </Stack>
    );
};